import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Launch",
  "use": "ico_Launch-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Launch\">\n    <path data-name=\"Union 8\" d=\"M3 21V5h7v1H4v14h14v-6h1v7zm7.645-8.351L19.182 4H13V3h8v8h-1V4.593l-8.644 8.758z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol